module.exports = __webpack_public_path__ + "img/icon-dropdown-close.453a55e5.svg";